<template>
 <div class="mask" id="mask" v-show="show">
        <div class="nstl-templet-div">
            <span></span>
            <div class="nstl-templet-div-txt">正在加载，请稍候...</div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text: {
      type: String,
      default: '正在加载中...'
    },
  }
}
</script>
<style >
@import "../../../static/cart/css/base.css";
@import "../../../static/cart/css/cart.css";
/* @import "../../../static/common/css/iconfont.css"; */
</style>



// WEBPACK FOOTER //
// src/assets/components/loading.vue